/**
 * DENETİM MODÜL ANAHTARINI OKUNABİLİR ADA ÇEVİRİR
 *
 * ================================================================
 * NEDEN AYRI BİR DOSYA
 * ================================================================
 * Aynı anahtar kümesi iki ekranda çiziliyor: "Etkinlik özeti" ve
 * Personel 360°'ın "İşlem geçmişi" sekmesi. İkisinde ayrı ayrı
 * yazsaydık biri güncellenip öteki kalırdı ve aynı sayı iki ekranda
 * iki farklı adla görünürdü.
 *
 * ================================================================
 * TANINMAYAN ANAHTAR HAM HÂLİYLE GEÇİYOR
 * ================================================================
 * Yeni bir modül eklendiğinde bu sözlüğe yazılmayı bekleyip ekranda
 * BOŞ görünmesindense, ham anahtarın görünmesi yeğ: "abonelik" yazan
 * bir satır okunabilir, boş bir satır okunamaz. Sözlük bir güzelleştirme,
 * bir kapı değil.
 */
const ADLAR: Record<string, string> = {
  // İş modülleri — sunucudaki `module` alanı.
  kisi: "Kişi kayıtları",
  gorusme: "Görüşmeler",
  program: "Program",
  mesaj: "Mesajlaşma",
  bildirim: "Bildirimler",
  analiz: "Analiz",
  kimlik: "Kimlik işlemleri",
  calisma: "Çalışma verisi",
  takvim: "Takvim",
  kvkk: "KVKK",
  rapor: "Veli raporları",
  onay: "Onaylar",
  akademik: "Müfredat",
  deneme: "Denemeler",
  finans: "Finans",
  kaynak: "Kaynaklar",
  operasyon: "Operasyon",
  sistem: "Sistem",
  yardim: "Yardım",
  yedek: "Yedekleme",
  denetim: "Denetim",
  crm: "Satış ve aday",

  /*
    MODÜLSÜZ OLAYLARIN KATEGORİSİ. Kimlik ve oturum olaylarının iş
    modülü yok; sunucu bu satırlarda kategoriyi yazıyor (gerekçe
    `etkinlik.service.ts` içinde). Eskiden hepsi "bilinmiyor" diye
    görünüyordu ve denetim ekranında en büyük grup oydu — olmayan bir
    şüphe üretiyordu.
  */
  identity: "Giriş ve kimlik",
  session: "Oturum ve cihaz",
  security: "Güvenlik olayları",
  authorization: "Yetki kontrolleri",
  data_read: "Veri okuma",
  data_change: "Veri değişikliği",
  workflow: "İş akışı",
  communication: "İletişim",
  system: "Sistem olayları",
};

export function modulAdi(anahtar: string): string {
  return ADLAR[anahtar] ?? anahtar;
}
